// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"24c31756","905":"2efdea04"}[chunkId] + ".chunk.js";
};